import { safeApiRequest, getApiBaseUrl, getStoredToken } from './apiClient';

const SERVICE_RECORDS_ENDPOINT = '/api/service-records';

/**
 * Servis kaydı payload'ını oluşturur
 */
const buildServiceRecordPayload = (payload = {}) => {
  const data = {};

  if (payload.musteriId !== undefined && payload.musteriId !== null && payload.musteriId !== '') {
    data.musteriId = payload.musteriId;
  }

  if (payload.islemTipi !== undefined && payload.islemTipi !== null && payload.islemTipi !== '') {
    const islemTipi = String(payload.islemTipi).trim();
    if (['Kurulum', 'Bakım', 'Arıza', 'İstek ve Şikayet'].includes(islemTipi)) {
      data.islemTipi = islemTipi;
    }
  }

  if (payload.cihazIds !== undefined && Array.isArray(payload.cihazIds)) {
    data.cihazIds = payload.cihazIds.filter(id => id);
  }

  if (payload.cihazSecilmedi !== undefined) {
    data.cihazSecilmedi = Boolean(payload.cihazSecilmedi);
  }

  if (payload.cihazAciklama !== undefined && payload.cihazAciklama !== '') {
    data.cihazAciklama = String(payload.cihazAciklama).trim();
  }

  if (payload.arizaIds !== undefined && Array.isArray(payload.arizaIds)) {
    data.arizaIds = payload.arizaIds.filter(id => id);
  }

  if (payload.arizaNotu !== undefined && payload.arizaNotu !== '') {
    data.arizaNotu = String(payload.arizaNotu).trim();
  }

  if (payload.adresId !== undefined && payload.adresId !== null && payload.adresId !== '') {
    data.adresId = payload.adresId;
  }

  if (payload.onemDerecesi !== undefined && payload.onemDerecesi !== '') {
    data.onemDerecesi = String(payload.onemDerecesi).trim();
  }

  if (payload.notlar !== undefined && payload.notlar !== '') {
    data.notlar = String(payload.notlar).trim();
  }

  // Teknik servis ID'leri (array olarak)
  if (payload.teknikServisId !== undefined && payload.teknikServisId !== null) {
    if (Array.isArray(payload.teknikServisId)) {
      data.teknikServisId = payload.teknikServisId.filter(id => id);
    } else if (payload.teknikServisId !== '') {
      data.teknikServisId = [payload.teknikServisId];
    }
  }

  // Kurulum: ürün (icerikId), seri no, gereksinim soru-cevapları
  if (payload.kurulumIcerikId !== undefined && payload.kurulumIcerikId !== null && String(payload.kurulumIcerikId).trim() !== '') {
    data.kurulumIcerikId = String(payload.kurulumIcerikId).trim();
  }
  if (payload.kurulumSeriNo !== undefined && payload.kurulumSeriNo !== null && String(payload.kurulumSeriNo).trim() !== '') {
    data.kurulumSeriNo = String(payload.kurulumSeriNo).trim().substring(0, 100);
  }
  if (
    payload.checklistTelefonCevaplari &&
    typeof payload.checklistTelefonCevaplari === 'object' &&
    Array.isArray(payload.checklistTelefonCevaplari.cevaplar) &&
    payload.checklistTelefonCevaplari.cevaplar.length > 0
  ) {
    data.checklistTelefonCevaplari = payload.checklistTelefonCevaplari;
  }
  if (payload.kurulumGereksinimler !== undefined && Array.isArray(payload.kurulumGereksinimler) && payload.kurulumGereksinimler.length > 0) {
    data.kurulumGereksinimler = payload.kurulumGereksinimler;
  }

  // İstek ve Şikayet alanları
  if (payload.istekSikayetKategorisi !== undefined && payload.istekSikayetKategorisi !== null && String(payload.istekSikayetKategorisi).trim() !== '') {
    data.istekSikayetKategorisi = String(payload.istekSikayetKategorisi).trim();
  }
  if (payload.istekSikayetTuru !== undefined && payload.istekSikayetTuru !== null && String(payload.istekSikayetTuru).trim() !== '') {
    const t = String(payload.istekSikayetTuru).trim();
    if (['İstek', 'Şikayet'].includes(t)) {
      data.istekSikayetTuru = t;
    }
  }
  if (payload.istekSikayetNotu !== undefined && payload.istekSikayetNotu !== null && String(payload.istekSikayetNotu).trim() !== '') {
    data.istekSikayetNotu = String(payload.istekSikayetNotu).trim().substring(0, 2000);
  }
  if (payload.hedefIcerikId !== undefined && payload.hedefIcerikId !== null && String(payload.hedefIcerikId).trim() !== '') {
    data.hedefIcerikId = String(payload.hedefIcerikId).trim();
  }
  if (payload.hedefCihazId !== undefined && payload.hedefCihazId !== null && String(payload.hedefCihazId).trim() !== '') {
    data.hedefCihazId = String(payload.hedefCihazId).trim();
  }
  if (payload.hedefTeknikServisId !== undefined && payload.hedefTeknikServisId !== null && String(payload.hedefTeknikServisId).trim() !== '') {
    data.hedefTeknikServisId = String(payload.hedefTeknikServisId).trim();
  }
  if (payload.hedefServisKaydiId !== undefined && payload.hedefServisKaydiId !== null && String(payload.hedefServisKaydiId).trim() !== '') {
    data.hedefServisKaydiId = String(payload.hedefServisKaydiId).trim();
  }

  if (payload.otpSmsTelefon !== undefined && payload.otpSmsTelefon !== null && String(payload.otpSmsTelefon).trim() !== '') {
    data.otpSmsTelefon = String(payload.otpSmsTelefon).trim();
  }

  if (payload.odemeBeyani === true || payload.odemeBeyani === 'true') {
    data.odemeBeyani = true;
  }

  return data;
};

/**
 * Garanti bitiş tarihini hesaplar
 * @param {string} garantiBaslangicTarihi - ISO formatında garanti başlangıç tarihi
 * @param {number} garantiSuresi - Ay cinsinden garanti süresi
 * @returns {string|null} ISO formatında garanti bitiş tarihi veya null
 */
const calculateGarantiBitisTarihi = (garantiBaslangicTarihi, garantiSuresi) => {
  if (!garantiBaslangicTarihi || !garantiSuresi || garantiSuresi <= 0) {
    return null;
  }
  
  try {
    const baslangic = new Date(garantiBaslangicTarihi);
    if (isNaN(baslangic.getTime())) {
      return null;
    }
    
    // Garanti süresini ekleme
    const bitis = new Date(baslangic);
    bitis.setMonth(bitis.getMonth() + garantiSuresi);
    
    return bitis.toISOString();
  } catch (error) {
    console.error('Garanti bitiş tarihi hesaplanamadı:', error);
    return null;
  }
};

/**
 * Randevu payload'ını oluşturur
 */
const buildAppointmentPayload = (payload = {}) => {
  const data = {};

  if (payload.randevuTarihi !== undefined && payload.randevuTarihi !== null) {
    data.randevuTarihi = payload.randevuTarihi;
  }

  // Eski sistemle uyumluluk için her iki field'ı da destekle
  if (payload.randevuSaati !== undefined && payload.randevuSaati !== '') {
    data.randevuSaati = String(payload.randevuSaati).trim();
  }
  if (payload.randevuSaatAraligi !== undefined && payload.randevuSaatAraligi !== '') {
    data.randevuSaatAraligi = String(payload.randevuSaatAraligi).trim();
  }
  if (payload.randevuSlotKodu !== undefined && payload.randevuSlotKodu !== '') {
    data.randevuSlotKodu = String(payload.randevuSlotKodu).trim();
  }

  if (payload.teknikServisId !== undefined && payload.teknikServisId !== null && payload.teknikServisId !== '') {
    data.teknikServisId = payload.teknikServisId;
  }

  if (payload.teknisyen !== undefined && payload.teknisyen !== null) {
    data.teknisyen = payload.teknisyen;
  }

  // Teknisyen ID'si direkt gelebilir (yeni sistem)
  if (payload.teknisyenId !== undefined && payload.teknisyenId !== null && payload.teknisyenId !== '') {
    data.teknisyenId = payload.teknisyenId;
  }

  if (payload.aciklama !== undefined && payload.aciklama !== '') {
    data.aciklama = String(payload.aciklama).trim();
  }

  // Garanti bitiş tarihini hesapla ve ekle
  if (payload.garantiBaslangicTarihi && payload.garantiSuresi) {
    const garantiBitisTarihi = calculateGarantiBitisTarihi(
      payload.garantiBaslangicTarihi,
      payload.garantiSuresi
    );
    if (garantiBitisTarihi) {
      data.garantiBitisTarihi = garantiBitisTarihi;
    }
  }

  return data;
};

/**
 * Servis kaydı oluştur
 */
export const createServiceRecord = async (payload) => {
  const data = buildServiceRecordPayload(payload);
  return safeApiRequest(SERVICE_RECORDS_ENDPOINT, {
    method: 'POST',
    body: data,
    skipCsrf: false,
  });
};

export const AKTIF_SK_TASLAK_YENILE_EVENT = 'aktif-sk-taslak-yenile';
export const AKTIF_SK_TASLAK_KAPATILDI_EVENT = 'aktif-sk-taslak-kapatildi';
const AKTIF_SK_HEADER_DISMISS_KEY = 'hlm-sk-taslak-header-dismissed-at';

/** Create sayfasındaki sihirbaz durumu — sunucu taslağı gecikse bile header göstergesi için. */
let localSkTaslakOzet = null;

export const setLocalSkTaslakOzet = (ozet) => {
  localSkTaslakOzet = ozet && (ozet.id || ozet.islemTipi) ? ozet : null;
  dispatchAktifSkTaslakYenile();
};

export const clearLocalSkTaslakOzet = () => {
  if (!localSkTaslakOzet) return;
  localSkTaslakOzet = null;
  dispatchAktifSkTaslakYenile();
};

export const getLocalSkTaslakOzet = () => localSkTaslakOzet;

export const dispatchAktifSkTaslakYenile = () => {
  if (typeof window !== 'undefined') {
    window.dispatchEvent(new CustomEvent(AKTIF_SK_TASLAK_YENILE_EVENT));
  }
};

/** Header’dan kapatılınca create sayfası erken taslak yeniden oluşturmasın. */
export const dispatchAktifSkTaslakKapatildi = () => {
  if (typeof window !== 'undefined') {
    window.dispatchEvent(new CustomEvent(AKTIF_SK_TASLAK_KAPATILDI_EVENT));
  }
};

/** Kapatmadan sonra eski taslakların header’da tekrar görünmesini engeller. */
export const markAktifSkTaslakHeaderDismissed = () => {
  try {
    if (typeof sessionStorage !== 'undefined') {
      sessionStorage.setItem(AKTIF_SK_HEADER_DISMISS_KEY, String(Date.now()));
    }
  } catch {
    /* ignore */
  }
};

export const clearAktifSkTaslakHeaderDismissed = () => {
  try {
    if (typeof sessionStorage !== 'undefined') {
      sessionStorage.removeItem(AKTIF_SK_HEADER_DISMISS_KEY);
    }
  } catch {
    /* ignore */
  }
};

export const getAktifSkTaslakHeaderDismissedAt = () => {
  try {
    if (typeof sessionStorage === 'undefined') return 0;
    const n = Number(sessionStorage.getItem(AKTIF_SK_HEADER_DISMISS_KEY) || 0);
    return Number.isFinite(n) ? n : 0;
  } catch {
    return 0;
  }
};

/** Dismiss sonrası yalnızca daha yeni (yeni ilerleme) taslak gösterilir. */
export const filterAktifTaslakAfterHeaderDismiss = (taslak) => {
  if (!taslak) return null;
  const dismissedAt = getAktifSkTaslakHeaderDismissedAt();
  if (!dismissedAt) return taslak;
  const t = new Date(taslak.guncellemeTarihi || taslak.olusturmaTarihi || 0).getTime();
  if (!t || t <= dismissedAt) return null;
  clearAktifSkTaslakHeaderDismissed();
  return taslak;
};

export const createTaslakServisKaydi = async (payload) => {
  const res = await safeApiRequest(`${SERVICE_RECORDS_ENDPOINT}/taslak`, {
    method: 'POST',
    body: payload,
    skipCsrf: false,
  });
  if (payload?.islemTipi) {
    clearAktifSkTaslakHeaderDismissed();
  }
  dispatchAktifSkTaslakYenile();
  return res;
};

export const patchTaslakServisKaydi = async (id, payload) => {
  const res = await safeApiRequest(`${SERVICE_RECORDS_ENDPOINT}/${id}/taslak`, {
    method: 'PATCH',
    body: payload,
    skipCsrf: false,
  });
  if (payload?.islemTipi) {
    clearAktifSkTaslakHeaderDismissed();
  }
  dispatchAktifSkTaslakYenile();
  return res;
};

export const tamamlaTaslakServisKaydi = async (id, payload) => {
  const data = buildServiceRecordPayload(payload);
  const res = await safeApiRequest(`${SERVICE_RECORDS_ENDPOINT}/${id}/tamamla`, {
    method: 'PATCH',
    body: data,
    skipCsrf: false,
  });
  dispatchAktifSkTaslakYenile();
  return res;
};

/**
 * Müşteri hub verisi: taslaklar, açık/geçmiş SK, müşteri özeti, adresler, cihazlar
 * @param {string} musteriId
 */
export const fetchServisKaydiHub = async (musteriId) => safeApiRequest(`${SERVICE_RECORDS_ENDPOINT}/hub`, {
  method: 'GET',
  query: { musteriId },
});

export const deleteTaslakServisKaydi = async (id) => {
  const res = await safeApiRequest(`${SERVICE_RECORDS_ENDPOINT}/${id}/taslak`, {
    method: 'DELETE',
  });
  dispatchAktifSkTaslakYenile();
  return res;
};

/** Kullanıcının en son güncellenen aktif taslak servis kaydı (header). */
export const fetchAktifTaslakServisKaydi = async () => safeApiRequest(
  `${SERVICE_RECORDS_ENDPOINT}/taslak/aktif`,
  { method: 'GET', skipCsrf: true },
);

export const fetchTaslakByGorusme = async (gorusmeKaydiId) => safeApiRequest(
  `${SERVICE_RECORDS_ENDPOINT}/taslak/by-gorusme/${encodeURIComponent(gorusmeKaydiId)}`,
  { method: 'GET' },
);

export const fetchTaslakByOnServis = async (onServisKaydiId) => safeApiRequest(
  `${SERVICE_RECORDS_ENDPOINT}/taslak/by-on-servis/${encodeURIComponent(onServisKaydiId)}`,
  { method: 'GET' },
);

/**
 * Servis kayıtlarını listele
 */
export const fetchServiceRecords = async ({ 
  page = 1, 
  limit = 50, 
  aktif = true,
  search,
  durum,
  durumlar,
  islemTipi,
  islemTipiHaric,
  teknikServisId,
  musteriId,
  istekSikayetKategorisi,
  istekSikayetTuru,
  hedefIcerikId,
  hedefTeknikServisId,
  baslangicTarihi,
  bitisTarihi,
} = {}) => {
  const queryParams = {};
  
  if (page) {
    queryParams.sayfa = page;
  }
  
  if (limit && limit !== 50) {
    queryParams.limit = limit;
  }
  
  if (aktif === false) {
    queryParams.aktif = 'false';
  }
  
  if (search && search.trim().length > 0) {
    queryParams.arama = search.trim();
  }
  
  if (Array.isArray(durumlar) && durumlar.length > 0) {
    queryParams.durumlar = durumlar.map((d) => String(d).trim()).filter(Boolean).join(',');
  } else if (durum && durum.trim().length > 0) {
    queryParams.durum = durum.trim();
  }
  
  if (islemTipi && islemTipi.trim().length > 0) {
    queryParams.islemTipi = islemTipi.trim();
  }

  if (islemTipiHaric && String(islemTipiHaric).trim().length > 0) {
    queryParams.islemTipiHaric = String(islemTipiHaric).trim();
  }
  
  if (teknikServisId) {
    queryParams.teknikServisId = teknikServisId;
  }

  if (musteriId) {
    queryParams.musteriId = musteriId;
  }

  if (istekSikayetKategorisi && String(istekSikayetKategorisi).trim().length > 0) {
    queryParams.istekSikayetKategorisi = String(istekSikayetKategorisi).trim();
  }

  if (istekSikayetTuru && String(istekSikayetTuru).trim().length > 0) {
    queryParams.istekSikayetTuru = String(istekSikayetTuru).trim();
  }

  if (hedefIcerikId) {
    queryParams.hedefIcerikId = hedefIcerikId;
  }

  if (hedefTeknikServisId) {
    queryParams.hedefTeknikServisId = hedefTeknikServisId;
  }

  if (baslangicTarihi) {
    queryParams.baslangicTarihi = baslangicTarihi;
  }

  if (bitisTarihi) {
    queryParams.bitisTarihi = bitisTarihi;
  }
  
  return safeApiRequest(SERVICE_RECORDS_ENDPOINT, {
    method: 'GET',
    query: queryParams,
    skipCsrf: true,
  });
};

/**
 * Açık kayıtlar — durum adet özeti (pill filtreleri)
 */
export const fetchAcikDurumOzet = async ({ search, islemTipi, islemTipiHaric } = {}) => {
  const queryParams = { islemTipiHaric: islemTipiHaric || 'İstek ve Şikayet' };
  if (search && String(search).trim().length > 0) {
    queryParams.arama = String(search).trim();
  }
  if (islemTipi && String(islemTipi).trim().length > 0) {
    queryParams.islemTipi = String(islemTipi).trim();
  }
  return safeApiRequest(`${SERVICE_RECORDS_ENDPOINT}/acik-durum-ozet`, {
    method: 'GET',
    query: queryParams,
    skipCsrf: true,
  });
};

/**
 * İstek/Şikayet hedef istatistikleri (en çok şikayet/istek alan üstte)
 * @param {Object} params - { kategori: 'Ürün' | 'Teknik Servis', tur?: 'İstek' | 'Şikayet' }
 */
export const fetchComplaintStats = async ({ kategori, tur } = {}) => {
  if (!kategori) {
    throw new Error('Kategori gereklidir');
  }
  const queryParams = { kategori };
  if (tur && String(tur).trim().length > 0) {
    queryParams.tur = String(tur).trim();
  }
  return safeApiRequest(`${SERVICE_RECORDS_ENDPOINT}/complaint-stats`, {
    method: 'GET',
    query: queryParams,
    skipCsrf: true,
  });
};

/**
 * Servis kaydı detayı
 */
export const fetchServiceRecordDetail = async (id) => {
  if (!id) {
    throw new Error('Servis kaydı ID gereklidir');
  }
  return safeApiRequest(`${SERVICE_RECORDS_ENDPOINT}/${id}`, {
    method: 'GET',
    skipCsrf: true,
  });
};

/**
 * Randevu Süresi Geçmiş → Randevu Bekleniyor (aktif randevuyu iptal eder)
 */
export const revertRandevuSuresiGecmis = async (id, not) => {
  if (!id) {
    throw new Error('Servis kaydı ID gereklidir');
  }
  const trimmed = String(not || '').trim();
  if (trimmed.length < 5) {
    throw new Error('En az 5 karakterlik bir not yazılmalıdır');
  }
  return safeApiRequest(`${SERVICE_RECORDS_ENDPOINT}/${id}/randevu-suresi-gecmis-geri-al`, {
    method: 'PATCH',
    body: { not: trimmed },
  });
};

export const toggleManuelDogrulama = async (id, aktif, not) => {
  if (!id) {
    throw new Error('Servis kaydı ID gereklidir');
  }
  if (typeof aktif !== 'boolean') {
    throw new Error('aktif alanı boolean olmalıdır');
  }
  const body = { aktif };
  if (not && String(not).trim()) {
    body.not = String(not).trim();
  }
  return safeApiRequest(`${SERVICE_RECORDS_ENDPOINT}/${id}/manuel-dogrulama`, {
    method: 'PATCH',
    body,
  });
};

/**
 * Servis kaydı güncelle (PUT)
 */
export const updateServiceRecord = async (id, payload = {}) => {
  if (!id) {
    throw new Error('Servis kaydı ID gereklidir');
  }
  const data = buildServiceRecordPayload(payload);
  return safeApiRequest(`${SERVICE_RECORDS_ENDPOINT}/${id}`, {
    method: 'PUT',
    body: data,
    skipCsrf: false,
  });
};

/** Teknik servis atamasını değiştir (aktif randevu iptal edilir) */
export const changeTechServiceOnServiceRecord = async (id, teknikServisId) => {
  if (!id) {
    throw new Error('Servis kaydı ID gereklidir');
  }
  if (!teknikServisId) {
    throw new Error('Teknik servis seçilmelidir');
  }
  return safeApiRequest(`${SERVICE_RECORDS_ENDPOINT}/${id}/change-tech-service`, {
    method: 'PATCH',
    body: { teknikServisId },
  });
};

/**
 * Randevu oluştur
 */
export const createAppointment = async (servisKaydiId, payload) => {
  if (!servisKaydiId) {
    throw new Error('Servis kaydı ID gereklidir');
  }
  const data = buildAppointmentPayload(payload);
  return safeApiRequest(`${SERVICE_RECORDS_ENDPOINT}/${servisKaydiId}/appointments`, {
    method: 'POST',
    body: data,
    skipCsrf: false,
  });
};

/**
 * Randevu müsaitlik durumunu sorgula (DEPRECATED - Kaldırıldı)
 * @param {string} tarih - YYYY-MM-DD formatında tarih
 * @param {string} teknikServisId - Teknik servis ID
 * @returns {Promise} Saatlik müsaitlik verisi
 * @deprecated Müsaitlik kontrolü kaldırılmıştır. Bu fonksiyon artık kullanılmamalıdır.
 */
export const fetchAppointmentAvailability = async (tarih, teknikServisId) => {
  if (!tarih || !teknikServisId) {
    throw new Error('Tarih ve teknik servis ID gereklidir');
  }
  const params = new URLSearchParams({
    tarih: String(tarih).trim(),
    teknikServisId: String(teknikServisId).trim(),
  });
  return safeApiRequest(`/api/appointments/availability?${params.toString()}`, {
    method: 'GET',
  });
};

/**
 * Randevu güncelle (teknik servis/teknisyen atama)
 */
export const updateAppointment = async (servisKaydiId, randevuId, payload) => {
  if (!servisKaydiId || !randevuId) {
    throw new Error('Servis kaydı ID ve Randevu ID gereklidir');
  }
  const data = buildAppointmentPayload(payload);
  return safeApiRequest(`${SERVICE_RECORDS_ENDPOINT}/${servisKaydiId}/appointments/${randevuId}`, {
    method: 'PUT',
    body: data,
    skipCsrf: false,
  });
};

/**
 * Randevu iptal et
 */
export const cancelAppointment = async (servisKaydiId, randevuId, iptalNedeni = '', userRole = null) => {
  if (!servisKaydiId || !randevuId) {
    throw new Error('Servis kaydı ID ve Randevu ID gereklidir');
  }
  const trimmed = String(iptalNedeni || '').trim();
  if (!trimmed || trimmed.length < 10) {
    throw new Error('İptal nedeni en az 10 karakter olmalıdır');
  }
  const data = { iptalNedeni: trimmed };
  
  // Kullanıcı rolüne göre endpoint seç
  // Admin/Mod: DELETE endpoint
  // Tech-service: PATCH cancel-by-tech-service endpoint (teknisyen iptal edemez)
  const role = (userRole || '').toLowerCase();
  if (role === 'tech-service') {
    return safeApiRequest(`${SERVICE_RECORDS_ENDPOINT}/${servisKaydiId}/appointments/${randevuId}/cancel-by-tech-service`, {
      method: 'PATCH',
      body: data,
      skipCsrf: false,
    });
  } else if (role === 'tech-person') {
    throw new Error('Randevu iptali sadece teknik servis tarafından yapılabilir');
  } else {
    // Admin/Mod için DELETE endpoint (iptal nedeni her durumda zorunlu, min 10 karakter)
    return safeApiRequest(`${SERVICE_RECORDS_ENDPOINT}/${servisKaydiId}/appointments/${randevuId}`, {
      method: 'DELETE',
      body: data,
      skipCsrf: false,
    });
  }
};

/**
 * Servis kaydına ait randevuları listele
 */
export const fetchAppointmentsByServiceRecord = async (servisKaydiId, { aktif = true, durum } = {}) => {
  if (!servisKaydiId) {
    throw new Error('Servis kaydı ID gereklidir');
  }
  const queryParams = {};
  // aktif parametresi varsa ekle, ama iptal edilen randevuları da görmek için durum filtresi kullanılabilir
  if (aktif === true) {
    queryParams.aktif = 'true';
  } else if (aktif === false) {
    queryParams.aktif = 'false';
  }
  // İptal edilen randevuları da görmek için durum filtresi eklenebilir
  if (durum) {
    queryParams.durum = durum;
  }
  return safeApiRequest(`${SERVICE_RECORDS_ENDPOINT}/${servisKaydiId}/appointments`, {
    method: 'GET',
    query: queryParams,
    skipCsrf: true,
  });
};

/**
 * Randevuya yapılan işlem ekle
 */
export const addAppointmentOperation = async (servisKaydiId, randevuId, payload) => {
  if (!servisKaydiId || !randevuId) {
    throw new Error('Servis kaydı ID ve Randevu ID gereklidir');
  }
  return safeApiRequest(`${SERVICE_RECORDS_ENDPOINT}/${servisKaydiId}/appointments/${randevuId}/operations`, {
    method: 'POST',
    body: payload,
    skipCsrf: false,
  });
};

/**
 * Randevuya ilave işlem ekle (mobil akış için)
 * POST /api/appointments/:randevuId/ilave-islem
 */
export const addAppointmentIlaveIslem = async (randevuId, payload) => {
  if (!randevuId) {
    throw new Error('Randevu ID gereklidir');
  }
  return safeApiRequest(`/api/appointments/${randevuId}/ilave-islem`, {
    method: 'POST',
    body: payload,
    skipCsrf: false,
  });
};

/**
 * Randevuya ilave parça ekle (mobil akış için)
 * POST /api/appointments/:randevuId/ilave-parca
 */
export const addAppointmentIlaveParca = async (randevuId, payload) => {
  if (!randevuId) {
    throw new Error('Randevu ID gereklidir');
  }
  return safeApiRequest(`/api/appointments/${randevuId}/ilave-parca`, {
    method: 'POST',
    body: payload,
    skipCsrf: false,
  });
};

/**
 * Randevuya değiştirilen parça ekle
 */
export const addAppointmentReplacedPart = async (servisKaydiId, randevuId, payload) => {
  if (!servisKaydiId || !randevuId) {
    throw new Error('Servis kaydı ID ve Randevu ID gereklidir');
  }
  return safeApiRequest(`${SERVICE_RECORDS_ENDPOINT}/${servisKaydiId}/appointments/${randevuId}/replaced-parts`, {
    method: 'POST',
    body: payload,
    skipCsrf: false,
  });
};

/**
 * Randevuyu tamamla (garanti ve fatura bilgileri)
 */
export const finishAppointment = async (servisKaydiId, randevuId, payload) => {
  if (!servisKaydiId || !randevuId) {
    throw new Error('Servis kaydı ID ve Randevu ID gereklidir');
  }
  return safeApiRequest(`${SERVICE_RECORDS_ENDPOINT}/${servisKaydiId}/appointments/${randevuId}/finish`, {
    method: 'PATCH',
    body: payload,
    skipCsrf: false,
  });
};

/**
 * Servis kaydı durumunu güncelle
 * @param {string} servisKaydiId
 * @param {string} durum
 * @param {Object} [extra] - Çözüldü için { cozumNotu: string }
 */
export const updateServiceRecordStatus = async (servisKaydiId, durum, extra = {}) => {
  if (!servisKaydiId) {
    throw new Error('Servis kaydı ID gereklidir');
  }
  if (!durum) {
    throw new Error('Durum gereklidir');
  }
  const body = { durum };
  if (durum === 'Çözüldü') {
    const not = extra?.cozumNotu ? String(extra.cozumNotu).trim() : '';
    if (!not || not.length < 5) {
      throw new Error('Çözüm notu en az 5 karakter olmalıdır');
    }
    body.cozumNotu = not.substring(0, 2000);
  }
  return safeApiRequest(`${SERVICE_RECORDS_ENDPOINT}/${servisKaydiId}/status`, {
    method: 'PATCH',
    body,
    skipCsrf: false,
  });
};

/**
 * Randevu durumunu güncelle
 */
export const updateAppointmentStatus = async (servisKaydiId, randevuId, durum) => {
  if (!servisKaydiId || !randevuId) {
    throw new Error('Servis kaydı ID ve Randevu ID gereklidir');
  }
  if (!durum) {
    throw new Error('Durum gereklidir');
  }
  return safeApiRequest(`${SERVICE_RECORDS_ENDPOINT}/${servisKaydiId}/appointments/${randevuId}/status`, {
    method: 'PATCH',
    body: { durum },
    skipCsrf: false,
  });
};

/**
 * Teknik servis ID'sine göre randevuları listele
 */
export const fetchAppointmentsByTechService = async (teknikServisId, { 
  page = 1, 
  limit = 50, 
  aktif = true,
  durum,
  teknisyenId,
  arama,
  baslangicTarihi,
  bitisTarihi,
  siralama,
} = {}) => {
  if (!teknikServisId) {
    throw new Error('Teknik servis ID gereklidir');
  }
  const queryParams = {
    teknikServisId,
    sayfa: page,
    limit: limit,
  };
  
  if (aktif === false) {
    queryParams.aktif = 'false';
  } else if (aktif === 'all') {
    queryParams.aktif = 'all';
  }
  
  if (durum) {
    queryParams.durum = durum;
  }

  if (teknisyenId) {
    queryParams.teknisyenId = teknisyenId;
  }

  if (arama) {
    queryParams.arama = arama;
  }

  if (baslangicTarihi) {
    queryParams.baslangicTarihi = baslangicTarihi;
  }

  if (bitisTarihi) {
    queryParams.bitisTarihi = bitisTarihi;
  }

  if (siralama) {
    queryParams.siralama = siralama;
  }
  
  return safeApiRequest('/api/appointments', {
    method: 'GET',
    query: queryParams,
    skipCsrf: true,
  });
};

/**
 * Randevu detayını getir
 */
export const fetchAppointmentDetail = async (randevuId) => {
  if (!randevuId) {
    throw new Error('Randevu ID gereklidir');
  }
  return safeApiRequest(`/api/appointments/${randevuId}`, {
    method: 'GET',
    skipCsrf: true,
  });
};

/**
 * Randevu detay raporu linkini getir (müşteriye SMS ile giden link)
 * Randevu tamamlandığında oluşturulan ServisKaydiRandevuDetay kaydından alır.
 */
export const fetchRandevuDetayLink = async (randevuId) => {
  if (!randevuId) {
    throw new Error('Randevu ID gereklidir');
  }
  return safeApiRequest(`/api/appointments/${randevuId}/randevu-detay-link`, {
    method: 'GET',
    skipCsrf: true,
  });
};

/**
 * Randevu formu meta bilgisi (PDF URL, OTP doğrulama metni)
 */
export const fetchRandevuFormuMeta = async (randevuId) => {
  if (!randevuId) throw new Error('Randevu ID gereklidir');
  return safeApiRequest(`/api/appointments/${randevuId}/randevu-formu`, {
    method: 'GET',
    skipCsrf: true,
  });
};

/**
 * Randevu formu PDF'ini yeni sekmede açar (yazdırma / indirme)
 */
export const openRandevuFormuPdf = async (randevuId) => {
  if (!randevuId) throw new Error('Randevu ID gereklidir');
  const base = getApiBaseUrl();
  const token = getStoredToken();
  const resp = await fetch(`${base}/api/appointments/${randevuId}/randevu-formu/pdf`, {
    method: 'GET',
    headers: token ? { Authorization: `Bearer ${token}` } : {},
    credentials: 'include',
  });
  if (!resp.ok) {
    let mesaj = 'Randevu formu PDF yüklenemedi';
    try {
      const err = await resp.json();
      mesaj = err?.mesaj || mesaj;
    } catch { /* ignore */ }
    throw new Error(mesaj);
  }
  const ct = resp.headers.get('content-type') || '';
  if (!ct.includes('application/pdf')) {
    throw new Error('Randevu formu PDF yüklenemedi (geçersiz yanıt)');
  }
  const blob = await resp.blob();
  const pdfBlob = blob.type === 'application/pdf'
    ? blob
    : new Blob([await blob.arrayBuffer()], { type: 'application/pdf' });
  const url = URL.createObjectURL(pdfBlob);
  window.open(url, '_blank', 'noopener,noreferrer');
  setTimeout(() => URL.revokeObjectURL(url), 120000);
};

/**
 * Teknisyen ata
 */
export const assignTechnician = async (randevuId, teknisyenId) => {
  if (!randevuId || !teknisyenId) {
    throw new Error('Randevu ID ve Teknisyen ID gereklidir');
  }
  return safeApiRequest(`/api/appointments/${randevuId}/assign-technician`, {
    method: 'PATCH',
    body: { teknisyenId },
    skipCsrf: false,
  });
};

/**
 * Atanmış teknisyeni değiştir (Randevu Tarihi Bekleniyor)
 */
export const reassignTechnician = async (randevuId, teknisyenId, gerekce = null) => {
  if (!randevuId || !teknisyenId) {
    throw new Error('Randevu ID ve Teknisyen ID gereklidir');
  }
  const body = { teknisyenId };
  if (gerekce && String(gerekce).trim()) {
    body.gerekce = String(gerekce).trim();
  }
  return safeApiRequest(`/api/appointments/${randevuId}/reassign-technician`, {
    method: 'PATCH',
    body,
    skipCsrf: false,
  });
};

/**
 * Atamayı iptal et
 */
/**
 * Atamayı iptal et
 * @param {string} randevuId - Randevu ID
 * @param {string} gerekce - İptal gerekçesi (min 10 karakter)
 * @param {string} iptalTipi - İptal tipi: "Teknik Servis İptali" veya "Teknisyen İptali" (default: "Teknik Servis İptali")
 * @param {string} [teknisyenId] - Teknisyen ID (sadece teknisyen iptali için gerekli)
 */
export const cancelAssignment = async (randevuId, gerekce, iptalTipi = 'Teknik Servis İptali', teknisyenId = null) => {
  if (!randevuId) {
    throw new Error('Randevu ID gereklidir');
  }
  if (!gerekce || gerekce.trim().length < 10) {
    throw new Error('İptal gerekçesi en az 10 karakter olmalıdır');
  }
  
  const body = {
    gerekce: gerekce.trim(),
    iptalTipi: iptalTipi
  };
  
  // Teknisyen iptali için teknisyen ID ekle
  if (iptalTipi === 'Teknisyen İptali' && teknisyenId) {
    body.teknisyenId = teknisyenId;
  }
  
  return safeApiRequest(`/api/appointments/${randevuId}/cancel-assignment`, {
    method: 'PATCH',
    body: body,
    skipCsrf: false,
  });
};

/**
 * Atama geçmişini getir
 */
export const fetchAssignmentHistory = async (randevuId) => {
  if (!randevuId) {
    throw new Error('Randevu ID gereklidir');
  }
  return safeApiRequest(`/api/appointments/${randevuId}/assignment-history`, {
    method: 'GET',
    skipCsrf: true,
  });
};

/**
 * Detaylı randevu bilgisini getir (tüm populate edilmiş verilerle)
 * @param {string} randevuId - Randevu ID
 */
export const fetchAppointmentDetailed = async (randevuId) => {
  if (!randevuId) {
    throw new Error('Randevu ID gereklidir');
  }
  return safeApiRequest(`/api/appointments/${randevuId}/detailed`, {
    method: 'GET',
    skipCsrf: true,
  });
};

/**
 * Randevu durum geçmişini getir
 * @param {string} randevuId - Randevu ID
 */
export const fetchStatusHistory = async (randevuId) => {
  if (!randevuId) {
    throw new Error('Randevu ID gereklidir');
  }
  return safeApiRequest(`/api/appointments/${randevuId}/status-history`, {
    method: 'GET',
    skipCsrf: true,
  });
};

/**
 * Randevuya teknik servis ata (Admin/Moderator için)
 * @param {string} randevuId - Randevu ID
 * @param {string} teknikServisId - Teknik servis ID
 */
export const assignTechServiceToAppointment = async (randevuId, teknikServisId) => {
  if (!randevuId) {
    throw new Error('Randevu ID gereklidir');
  }
  if (!teknikServisId) {
    throw new Error('Teknik servis ID gereklidir');
  }
  return safeApiRequest(`/api/appointments/${randevuId}/assign-tech-service`, {
    method: 'PATCH',
    body: { teknikServisId },
    skipCsrf: false,
  });
};

/**
 * Randevuya teknisyen ata (Admin/Sales/TechService için) - Prompt#43
 * @param {string} serviceRecordId - Servis kaydı ID
 * @param {string} appointmentId - Randevu ID
 * @param {Object} data - { teknisyenId, gerekce }
 */
export const assignTechnicianToAppointment = async (serviceRecordId, appointmentId, data) => {
  if (!serviceRecordId) {
    throw new Error('Servis kaydı ID gereklidir');
  }
  if (!appointmentId) {
    throw new Error('Randevu ID gereklidir');
  }
  if (!data.teknisyenId) {
    throw new Error('Teknisyen ID gereklidir');
  }
  return safeApiRequest(`/api/service-records/${serviceRecordId}/appointments/${appointmentId}/assign-technician`, {
    method: 'POST',
    body: data,
    skipCsrf: false,
  });
};

/**
 * Randevudan teknisyen çıkar (Admin/Sales/TechService için) - Prompt#43
 * @param {string} serviceRecordId - Servis kaydı ID
 * @param {string} appointmentId - Randevu ID
 * @param {string} reason - İptal gerekçesi
 */
export const cancelTechnicianFromAppointment = async (serviceRecordId, appointmentId, reason) => {
  if (!serviceRecordId) {
    throw new Error('Servis kaydı ID gereklidir');
  }
  if (!appointmentId) {
    throw new Error('Randevu ID gereklidir');
  }
  return safeApiRequest(`/api/service-records/${serviceRecordId}/appointments/${appointmentId}/cancel-technician`, {
    method: 'POST',
    body: { gerekce: reason || '' },
    skipCsrf: false,
  });
};

/**
 * Randevudan teknik servis çıkar (Admin/Sales için) - Prompt#43
 * @param {string} serviceRecordId - Servis kaydı ID
 * @param {string} appointmentId - Randevu ID
 * @param {string} reason - İptal gerekçesi
 */
export const cancelTechServiceFromAppointment = async (serviceRecordId, appointmentId, reason) => {
  if (!serviceRecordId) {
    throw new Error('Servis kaydı ID gereklidir');
  }
  if (!appointmentId) {
    throw new Error('Randevu ID gereklidir');
  }
  return safeApiRequest(`/api/service-records/${serviceRecordId}/appointments/${appointmentId}/cancel-tech-service`, {
    method: 'POST',
    body: { gerekce: reason || '' },
    skipCsrf: false,
  });
};

/**
 * Manuel randevu durum değiştirme (Admin/Sales için) - Prompt#43
 * @param {string} appointmentId - Randevu ID
 * @param {string} newStatus - Yeni durum
 * @param {string} reason - Değişiklik gerekçesi
 */
export const updateAppointmentStatusManual = async (appointmentId, newStatus, reason) => {
  if (!appointmentId) {
    throw new Error('Randevu ID gereklidir');
  }
  if (!newStatus) {
    throw new Error('Yeni durum gereklidir');
  }
  return safeApiRequest(`/api/appointments/${appointmentId}/status`, {
    method: 'PATCH',
    body: { durum: newStatus, gerekce: reason || '' },
    skipCsrf: false,
  });
};

/**
 * Teknisyen randevu durum değiştirme (Mobile / Randevu Test için)
 * PATCH /api/appointments/:randevuId/update-status
 * @param {string} randevuId - Randevu ID
 * @param {Object} payload - { yeniDurum, notlar?, sonrakiIslem?, iptalNedeni?, iptalAciklamasi? }
 */
export const updateAppointmentStatusTeknisyen = async (randevuId, payload) => {
  if (!randevuId) {
    throw new Error('Randevu ID gereklidir');
  }
  if (!payload?.yeniDurum) {
    throw new Error('yeniDurum gereklidir');
  }
  return safeApiRequest(`/api/appointments/${randevuId}/update-status`, {
    method: 'PATCH',
    body: {
      yeniDurum: payload.yeniDurum,
      notlar: payload.notlar ?? undefined,
      sonrakiIslem: payload.sonrakiIslem ?? undefined,
      iptalNedeni: payload.iptalNedeni ?? undefined,
      iptalAciklamasi: payload.iptalAciklamasi ?? undefined,
    },
    skipCsrf: false,
  });
};